module.exports = __webpack_public_path__ + "img/qrcode.d01a48b5.png";